import script from "./EntityLockAvatarTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityLockAvatarTemplate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress});
